import React from 'react'
import { graphql } from 'gatsby'
import { compose } from 'ramda'
import marked from 'marked'
import ReactHtmlParser from 'react-html-parser'

import Layout from '../../components/layout'
import withHelmet from '../../components/hoc/withHelmet'
import { contentfulSelector, repeat } from '../../utils'

import Hero from '../../components/Hero/Hero'
import IconCallouts from '../../components/IconCallouts/IconCallouts'
import ListCallouts from '../../components/ListCallouts/ListCallouts'
import Help from '../../components/Help/Help'

import styles from './pay-bills.module.scss'

const fromMarkup = compose(
  ReactHtmlParser,
  marked
)

const pbSelector = contentfulSelector('contentfulPayBillsPage')

const selectHeroImage = pbSelector(['hero', 'file', 'url'])
const selectTitle = pbSelector(['title'])
const selectDescription = pbSelector(repeat('description'))
const selectIconCallouts = pbSelector(['iconCallouts'])
const selectBPCalloutDescription = pbSelector(
  repeat('billPayCalloutsDescription')
)
const selectBPCallouts = pbSelector(['billPayCallouts'])
const selectBPHelp = pbSelector(repeat('helpDescription'))

export default withHelmet(pbSelector)(PayBills)

function PayBills({ data }) {
  return (
    <Layout>
      <Hero
        className={styles.hero}
        titleClassName={styles.heroTitle}
        imageSrc={selectHeroImage(data)}
        title={selectTitle(data)}
      />
      <div className={styles.description}>
        <div className={styles.descriptionInner}>
          {fromMarkup(selectDescription(data))}
        </div>
      </div>
      <IconCallouts callouts={selectIconCallouts(data)} />
      <ListCallouts
        title={fromMarkup(selectBPCalloutDescription(data))}
        callouts={selectBPCallouts(data)}
      />
      <Help description={fromMarkup(selectBPHelp(data))} />
    </Layout>
  )
}

export const query = graphql`
  query PayBillsQuery {
    contentfulPayBillsPage {
      fields {
        slug
        jsonLd
      }
      seoFields {
        title
        description {
          description
        }
        pageTitle
        ogImage {
          file {
            url
          }
        }
      }
      title
      hero {
        file {
          url
        }
      }
      description {
        description
      }
      iconCallouts {
        title
        icon
        description {
          description
        }
      }
      billPayCalloutsDescription {
        billPayCalloutsDescription
      }
      billPayCallouts
      helpDescription {
        helpDescription
      }
    }
  }
`
